







import { Component, Prop, Vue } from "vue-property-decorator";
import { GasyaResultUnit, RARITY } from "@/constants";
import ResultSceneBackground from "@/components/ResultSceneBackground.vue";

@Component({ components: { ResultSceneBackground } })
export default class BitetheUnitComponent extends Vue {
  @Prop() unit!: GasyaResultUnit;
  readonly w = 792;
  readonly h = 792 * 1.5;
  get currenRarity(): RARITY {
    return this.unit?.rarity;
  }
  get tdStyle(): { background: string } {
    return {
      background: `url(${this.unit?.pictureurl}) center center / contain no-repeat`,
    };
  }
}
